<template>

        <td>
              <span style="width: 60px; display: inline-block">{{ volume }}</span>
                <div  style="padding: 0 !important; display: inline-block">
    <div class="inCellHeight" v-if="trend !== undefined && trend !== null" :class="setColor()">
      <i :class="setIcon()"/>
    </div>
    <div class="inCellHeight" v-else>
      -
    </div>
  </div>

            </td>

</template>

<script>
export default {
  name: "VolumeCell",
  props: ['volume', 'trend'],
  methods: {
    setIcon() {

      return this.trend === 1 ? 'ri-arrow-right-up-line' : this.trend === -1 ? 'ri-arrow-right-down-line' : 'ri-pulse-line';
    },
    setColor() {
      return this.trend === 1 ? 'green' : this.trend === -1 ? 'red' : 'neutral';
    }
  }
}
</script>

<style scoped lang="scss">
div {
    margin: -3px;
  padding: 7.5px 10px !important;
}


</style>
